import { createRoute } from '@tanstack/react-router';
import ClientsPage from '@/features/dashboard/clients/pages/ClientsPage.tsx';
import { appRoute } from '@/features/dashboard/_root/routes/appRoute.tsx';
import { listSearchSchema } from '@/components/table/routes/listSearchParams.ts';

export const clientsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/clients',
  component: ClientsPage,
  validateSearch: listSearchSchema,
});
